var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "h-100" }, [
    !_vm.isInvite
      ? _c(
          "div",
          {
            staticClass: "h-100 d-flex flex-column",
            on: {
              dragover: function($event) {
                $event.preventDefault()
              },
              drop: function($event) {
                $event.preventDefault()
                return _vm.fileDropHandler($event)
              }
            }
          },
          [
            _c(
              "div",
              {
                ref: "scrollable-content",
                staticClass: "flex-grow-1",
                staticStyle: { "overflow-y": "auto" }
              },
              [
                _c(
                  "div",
                  { staticClass: "chatroom-message-section position-relative" },
                  [
                    _vm.fetchingMessages
                      ? _c("div", [
                          _c(
                            "div",
                            {
                              staticClass: "text-center p-3 font-grey-gallery"
                            },
                            [_vm._v("Chargement des messages...")]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.chatroom.messages != undefined &&
                    _vm.chatroom.messages.length == 0 &&
                    !_vm.fetchingMessages
                      ? _c("div", [
                          _c(
                            "div",
                            {
                              staticClass: "text-center p-3 font-grey-gallery"
                            },
                            [_vm._v("Aucun messages à afficher")]
                          )
                        ])
                      : _c(
                          "div",
                          _vm._l(_vm.reversedMessages, function(
                            message,
                            index
                          ) {
                            return _c("feed-message", {
                              key: index,
                              attrs: {
                                message: message,
                                fileAttachmentImageUrl:
                                  "chatroom/files/%fileid%/image",
                                fileAttachmentThumbnailUrl:
                                  "chatroom/files/%fileid%/thumbnail",
                                fileAttachmentDownloadUrl:
                                  "chatroom/files/%fileid%/download"
                              },
                              on: {
                                resendMessage: function($event) {
                                  return _vm.submitMessage($event, true)
                                },
                                deleteMessage: _vm.deleteMessage
                              }
                            })
                          }),
                          1
                        )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "chatroom-compose-message" }, [
              _c(
                "div",
                {
                  staticClass: "avatar",
                  style: { backgroundColor: _vm.user.user_background_color }
                },
                [_vm._v(" " + _vm._s(_vm.user.user_initials) + " ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ml-2 flex-grow-1 position-relative" },
                [
                  _c("fancy-textarea-box", {
                    ref: "message-box",
                    attrs: { disabled: _vm.sendingMessage },
                    on: {
                      enterPressed: _vm.sendMessage,
                      toolClick: _vm.toolClick
                    },
                    model: {
                      value: _vm.current_message,
                      callback: function($$v) {
                        _vm.current_message = $$v
                      },
                      expression: "current_message"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "position-absolute",
                staticStyle: { opacity: "0", "pointer-events": "none" }
              },
              [
                _c("input", {
                  ref: "message-file-upload",
                  attrs: { type: "file", multiple: "" },
                  on: { change: _vm.handleFileUploadFromInput }
                })
              ]
            )
          ]
        )
      : _c(
          "div",
          {
            staticClass:
              "h-100 d-flex align-items-center justify-content-center flex-column"
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", [
              _vm._v(
                "Vous avez une invitation à la conversation. Joindre la conversation?"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-4" }, [
              _c(
                "button",
                {
                  staticClass: "btn green-jungle",
                  on: { click: _vm.acceptInvite }
                },
                [_vm._v("Accepter")]
              ),
              _vm._v(" ou\n      "),
              _c(
                "button",
                { staticClass: "btn red", on: { click: _vm.rejectInvite } },
                [_vm._v("Refuser")]
              )
            ])
          ]
        )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { "font-size": "122px", opacity: "0.7" } },
      [_c("i", { staticClass: "icon-user-follow" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }